// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronUp48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronUp48: FC<ChevronUp48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m38.4 27.314-2.416 2.972L24 20.48l-11.984 9.806L9.6 27.314 24 15.521l14.4 11.793Z" />
        </svg>
    );
};

export default ChevronUp48;
